const requireHistory =  require('history')

import { applyMiddleware, compose, createStore, } from 'redux'
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { routerMiddleware } from 'react-router-redux'
export const history = requireHistory.createBrowserHistory()

const routeMiddleware = routerMiddleware(history);

const middlewares = [
  thunk,
  routeMiddleware
]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(...middlewares))
)

export default store